import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import Loading from "../components/Loading";
import BreadcrumbFolderLayout from "../components/BreadcrumbFolderLayout";
import { AddFolderButton, SmallScreenModel } from "components";
import { VideoGroupProps } from "../group/store/actionType";
import { VideoCategoryProps } from "./store/actionType";
import CategoryCard from "./page/component/CategoryCard";
import CreateCategory from "./page/CreateCategory";
import { fetchVideoCategories } from "./store/action";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const Category: React.FC<Props> = ({
  videoCategoriesState,
  onFetchVideoCategories,
}) => {
  const navigate = useNavigate();
  const { groupId } = useParams<{ groupId: string }>();
  const groupsState = useSelector(
    (state: any) => state.videoGroups.videoGroupsState
  );
  const currentGroup = groupsState.groups?.filter(
    (group: VideoGroupProps) => group.id === groupId
  )[0];
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => {
    setModalOpen(false);
  };
  const handleSectionClick = (id: string) => {
    navigate(`/video/${groupId}/${id}`);
  };
  const redirectToGroup = () => {
    navigate(`/video`);
  };

  useEffect(() => {
    onFetchVideoCategories(groupId ?? "");
  }, []);

  const breadcrumbItem = [
    {
      group: "Group",
      root: "Root",
      active: true,
      onClick: () => redirectToGroup(),
    },
    { group: currentGroup?.name, root: "Group" },
  ];
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_CATEGORY));
  return (
    <div className="h-full overflow-hidden">
      {videoCategoriesState && videoCategoriesState.isLoading && <Loading />}
      <BreadcrumbFolderLayout
        groupData={videoCategoriesState?.categories}
        breadcrumbItem={breadcrumbItem}
        addFolderButton={
          <>
            {isPermitted && (
              <AddFolderButton onClick={() => setModalOpen(true)}>
                Create Category
              </AddFolderButton>
            )}
          </>
        }
        folders={
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {videoCategoriesState &&
                videoCategoriesState?.categories &&
                videoCategoriesState?.categories.map(
                  (categoryData: VideoCategoryProps) => (
                    <CategoryCard
                      key={categoryData.id}
                      categoryData={categoryData}
                      onClick={() => handleSectionClick(categoryData.id)}
                    />
                  )
                )}
            </div>
          </>
        }
      />
      <SmallScreenModel setShowModal={setModalOpen} showModal={isModalOpen}>
        <CreateCategory closeModal={closeModal} groupId={currentGroup.id} />
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  videoCategoriesState: state.videoCategories.videoCategoriesState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchVideoCategories: (group_id: string) =>
    dispatch(fetchVideoCategories(group_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Category);
